module.exports = __webpack_public_path__ + "img/kerala_login_bg.74a6351a.jpg";